import React, { Component } from "react"

import { searchifySelectGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    LegislativeStatCategorySelect,
    DemographicStatCategorySelect,
} from "app/static/frontend/selects/containers/PieSelect"

export class StatisticNameLegislativeFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legStatNameFilter",
            filterKey: "legislative_category_ids",
            selectComponent: LegislativeStatCategorySelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StatisticNameDemographicFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "demStatNameFilter",
            filterKey: "demographic_category_ids",
            selectComponent: DemographicStatCategorySelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
